export default __webpack_public_path__ + "static/screens-bottom-dac1ecf05a0361336cd21fa10cdef882.jpg";